










import mixins from 'vue-typed-mixins';
import { Survey } from '@/utils/SurveyUtils';
import DashboardCanvasVue from '@/components/dashboard/DashboardCanvas.vue';
import dashboard from '@/router/routes/dashboard';
export default mixins().extend({
  components: {
    DashboardCanvas: DashboardCanvasVue,
  },

  props: {
    value: {
      type: Object as () => Survey,
    },
  },

  methods: {
    submit() {
      this.$emit('submit', this.value);
    },

    handlePristine(pristine: Partial<Survey>) {
      this.$emit('pristine', pristine);
    },
  },
});
